import { render, staticRenderFns } from "./myReceiveResume.vue?vue&type=template&id=ce9ad59c&"
import script from "./myReceiveResume.vue?vue&type=script&lang=js&"
export * from "./myReceiveResume.vue?vue&type=script&lang=js&"
import style0 from "./myReceiveResume.vue?vue&type=style&index=0&id=ce9ad59c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports